module.exports = __webpack_public_path__ + "img/es-ga.405f191.svg";